import { promoConstants } from '../constants/promo';

const initialState = {
  promoHistory: []
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case promoConstants.SET_PROMO_HISTORY_OFFERS_SUCCESS:
      return { ...state, promoHistory: action.history };
    case promoConstants.SET_PROMO_CODE_SUCCESS:
      return { ...state }
    default:
      return state;
  }
};
